import styles from './PillModal.module.scss';
import React, { FC } from 'react';

import { Modal } from 'components/Modal/Modal';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { IconType } from 'components/Icon/Icon';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';
import { SubjectImage } from 'components/SubjectImage/SubjectImage';
import { TextV2 } from 'components/TextV2/TextV2';
import { TextWithArrow } from 'components/TextWithArrow/TextWithArrow';
import { toEntry } from 'services/cms/typesUtil';
import { FeatureGardenPillProps } from '../FeatureGarden';
import { IconButton } from 'components/IconButton/IconButton';

export const PillModal: FC<FeatureGardenPillProps> = entry => (
  <Modal
    isOpen={!!entry.isModalOpen}
    className={styles.openPill}
    overlayClassName={styles.openPillOverlay}
    onRequestClose={entry.onRequestClose}
  >
    <div className={styles.openPillHeading}>
      <SubjectImage entry={entry} className={styles.openPillImage} />
      <TextV2 variant="modern-h4" value={entry.title} className={styles.openPillTitle} />
      <IconButton
        type={IconType.CLOSE}
        className={styles.openPillHeadingCloseButton}
        onClick={entry.onRequestClose}
      />
    </div>
    <TextV2 variant="modern-body" value={entry.blurb} className={styles.openPillBlurb} />
    <RichBlurb document={entry.richBlurb} className={styles.openPillBlurb} />
    {entry.link && (
      <ContentLinkV2 entry={toEntry(entry.link)} className={styles.openPillLink} hideTitle>
        <TextWithArrow>{entry.link.title}</TextWithArrow>
      </ContentLinkV2>
    )}
  </Modal>
);
